import { useEffect } from 'react';
import { Box, Icon, Link, Text } from '@nimbus-ds/components';
import { ExternalLinkIcon, ForbiddenIcon } from '@nimbus-ds/icons';
import { trackingNuvemDomainsNotAvailable } from 'domains/Configurations/Domains/tracking';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';

interface DomainNotAvailableTldCardProps {
  domain: string;
}

const HELP_URL =
  'https://ayuda.tiendanube.com/es_MX/175782-abc-del-dominio-propio/como-conseguir-mi-dominio-propio?utm_source=newadmin&utm_medium=domain&utm_campaign=CAN';

export function DomainNotAvailableTldCard({
  domain,
}: DomainNotAvailableTldCardProps) {
  const t = useTranslationConfigurations(
    'domains.landing.addDomainModal.searchNewDomain.domainNotAvailableTld',
  );
  const tld = domain.split('.').pop() || '';

  useEffect(() => {
    trackingNuvemDomainsNotAvailable('other_tld');
  }, []);

  return (
    <Box
      borderColor="danger-surfaceHighlight"
      borderStyle="solid"
      borderWidth="1"
      borderRadius="2"
      padding="4"
      display="flex"
      flexDirection="column"
      boxShadow="2"
      gap="2"
    >
      <Box display="flex" alignItems="center" gap="1">
        <Icon source={<ForbiddenIcon size="small" />} color="danger-textLow" />
        <Text fontSize="base" color="danger-textLow">
          {t('title', { tld })}
        </Text>
      </Box>
      <Text fontSize="caption" color="neutral-textLow">
        {t('description', { tld })}
      </Text>
      <Link
        as="a"
        href={HELP_URL}
        appearance="primary"
        textDecoration="none"
        target="_blank"
      >
        {t('helpLink')}{' '}
        <Icon color="primary-interactive" source={<ExternalLinkIcon />} />
      </Link>
    </Box>
  );
}
